<div class="trinka_cloud_wrap">

    <div class="trinka_cloud_wrap1">
        <div class="cloud_top_banners">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="trinka_cloud_banner_text">
                            <h1>Verificador de Citações</h1>
                            <h2>Fortaleça Sua Argumentação de Pesquisa</h2>
                            <p>O Verificador de Citações do Trinka faz uma análise automatizada das citações para identificar aquelas que podem enfraquecer sua premissa de pesquisa e sua argumentação, e ajuda você a fazer citações com credibilidade e autoridade no seu artigo.</p>
                            <a href="https://cloud.trinka.ai/signup?_rg=PT" id="autoEditGetStart" target="_blank">Verifique Agora</a>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                            <img src="../../../assets/images/Reference-Quality-Check.png" alt="Citation Checker">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="how_it_work_section" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>How It Works</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/RegisterAndLogin.png" alt="login">
                                </div>
                                <h3>Register / Login</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="import">
                                </div>
                                <h3>Select auto file edit <br />& upload your file</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="improve writing">
                                </div>
                                <h3>Download file with<br /> track changes </h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/citation-video.png" alt="citation thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>Veja-o em ação</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">Veja como funciona o Verificador de Citações do Trinka e comece a usá-lo sem demora.</p>
                        <p style="margin-bottom: 10px;">O vídeo de apresentação, fácil de acompanhar, ajudará você a extrair o máximo deste recurso.</p>
                        <p>Ainda tem perguntas? Dê uma olhada nas nossas Perguntas Frequentes <a style="color: #0000ff;" (click)="scroll(target)" class="link">aqui</a>.</p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Principais Recursos do Verificador de Citações do Trinka</h2>
                        <div class="HeadingSubLine"></div>
                        <p>O Verificador de Citações do Trinka identifica vários riscos de qualidade através de uma análise robusta de citações, que permite que você melhore sua lista de citações e fortaleça sua argumentação de pesquisa.</p>
                    </div>
                </div>
            </div>
            <div class="row match-box">

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Retracted-References.png" alt="retracted reference">
                        <h3>Citações Retratadas</h3>
                        <p>Identifique estudos que foram retratados após a publicação e evite críticas dos pares revisores.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Non-standard-References.png" alt="standard references">
                        <h3>Citações Fora do Padrão</h3>
                        <p>Melhore a credibilidade das suas citações eliminando trabalhos não revisados por pares.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/low-visibility.png" alt="low visibility">
                        <h3>Citações de Baixa Visibilidade</h3>
                        <p>Identifique citações que não foram citadas com frequência por outros autores, para evitar enfraquecer a sua argumentação.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Old-References.png" alt="old references">
                        <h3>Referências Antigas</h3>
                        <p>Identifique facilmente artigos publicados há muito tempo, para garantir uma alta relevância e validade das suas citações.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Overuse.png" alt="overuse">
                        <h3>Excesso de Citações de um Mesmo Periódico</h3>
                        <p>Identifique vieses involuntários em favor de certos periódicos e evite críticas dos pares revisores ao diversificar suas fontes de citações.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="uploadOptionSection">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Por Que Escolher o Verificador de Citações do Trinka</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row match-box">
                <div class="col-sm-6 dflex">
                    <div class="c-card trinka-checker rchecker">
                        <div class="media">
                            <div class="media-left">
                                <img src="../../../../assets/images/languageScore_icon.svg" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>Visão Geral Gratuita da Pontuação</h3>
                                <p>Gere pontuações de análises de citações gratuitamente e pague apenas pelo relatório completo, quando necessário.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="c-card trinka-checker">
                        <div class="media">
                            <div class="media-left">
                                <img src="../../../../assets/images/Up-to-date-Repository.png" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>Validação de Referências Cruzadas</h3>
                                <p>Todas as suas citações são validadas contra um extenso repositório de referências cruzadas de publicações, que tem a confiança de editores e organizações de todo o mundo.</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="key_features_heading">
                        <h2>Veja um Exemplo de Relatório</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Veja um exemplo de relatório de análise de citações pelo Verificador de Citações do Trinka para entender como seu artigo pode se beneficiar dele!</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="viewSampleReportImg">
                        <a href="citation-checker/sample-report/">Ver Relatório Completo <i class="fa fa-arrows-alt" aria-hidden="true"></i></a>
                        <img src="../../../assets/images/citation-report.jpg" alt="citation checker report">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>Obtenha Sua Pontuação de Análise de Citações Gratuitamente Agora</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Comece a Usar</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>O Verificador de Citações Usa Créditos</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        
                        <div class="featurePointsCredits">
                            <span>
                                <img src="../../../assets/images/credits_icon.png" alt="credits">
                            </span>
                            <p>Pontuações de análise de citações são gratuitas; você só precisa pagar pelo relatório completo. Para gerar o relatório é usado 1 crédito para até 10 citações. Use créditos gratuitos ou compre mais conforme a necessidade.</p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 0px;">Créditos são como fichas que permitem a você usar vários recursos do Trinka conforme a necessidade.</p>
                            <p>Usuários Premium ganham 10 créditos gratuitos por mês e usuários do Plano Básico ganham 4. Para saber mais, <a [routerLink]="['/features/credits']">clique aqui</a>.</p>
                        </div>
                    </div>
                </div>
                
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Free Credits Available</h3>
                        </div>
                        <p>Basic users get 2 and Premium users get 5 free credits every month. Unused free credits expire at month end.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Credits Consumed</h3>
                        </div>
                        <p>Auto File Edit uses 1 credit for every 5000 words. You may upload larger files; credits required will be shown and consumed accordingly. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Buy More Credits</h3>
                        </div>
                        <p>If you need additional credits, you can purchase them whenever needed. Purchased Credits do not expire.</p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>Perguntas Frequentes</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Como funciona o Verificador de Citações do Trinka?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>Melhore a qualidade das suas citações em 3 passos simples!</h4>
                                        <ol>
                                            <li><a href="https://cloud.trinka.ai/signup" target="_blank">Inscreva-se</a> gratuitamente no Trinka.  </li>
                                            <li>Vá até a página do Verificador de Citações, a partir do painel de navegação à esquerda. </li>
                                            <li>Envie o seu documento. Você pode enviá-lo a partir do Google Drive, OneDrive, Dropbox ou do seu computador. Você também pode usar documentos já enviados ao Trinka. Você obterá seu relatório em alguns minutos!</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        Onde posso acessar o Verificador de Citações do Trinka?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>No momento, o Verificador de Citações do Trinka está disponível apenas na plataforma Trinka Cloud, para todos os usuários. Em breve, ele também estará disponível no add-in para o Word. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        O Trinka analisa citações localizadas atrás de paywalls?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Sim. Podemos verificar a qualidade das suas citações mesmo que elas tenham sido publicadas em periódicos com paywalls.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Posso compartilhar o relatório de citações com meus coautores?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                        <p>No momento, o relatório não pode ser compartilhado. Tornaremos isso possível no futuro! </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Use o Trinka em outros aplicativos</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/wordplugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word Add-in</h3>
                                        </div>
                                </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="bowser plugin">
                                            <h3>Plugins do navegador</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/enterprise']">
                                        <div class="app_name_content" style="padding: 0px;">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">Empresas</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XBuFdCM3xtk"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>